import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

export const useGiftCardsRevampFF = () => {
  return useFeatureFlag(FEATURE_FLAGS.GIFT_CARDS_REVAMP);
};
